import React from 'react';
import { BootstrapStyles } from '../styles/spBootstrapExtended';
import { PageHeadStyles } from '../shared/components/PageHead';
import { SiteGlobalStyles } from '../styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function LayoutMain(props) {
  return /*#__PURE__*/_jsxs(React.Fragment, {
    children: [/*#__PURE__*/_jsx(BootstrapStyles, {}), /*#__PURE__*/_jsx(SiteGlobalStyles, {}), /*#__PURE__*/_jsx(PageHeadStyles, {}), /*#__PURE__*/_jsxs("div", {
      "data-testid": "root-layout",
      children: [props.alert, props.navigation, /*#__PURE__*/_jsx("div", {
        className: "main",
        children: /*#__PURE__*/_jsx("div", {
          id: "content",
          children: props.content
        })
      }), props.footer]
    })]
  });
}